import AppContainer from './Dashboard';
import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import home from './Home/home.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import manualRoutes from '../manual/manual.routes';
import { routes as crm } from './crm/routes';
import { routes as wise } from './wise/wise.routes';
import { routes as smart_survey } from './smartsurvey/routes';
import { routes as typebot } from './typebot/routes';
import { routes as campaignsFlow } from './campaignsFlow/routes';
import { routes as dashboardEmbed } from './dashboardEmbed/routes';

const Suspended = () => import('./suspended/Index');

export default {
  routes: [
    ...helpcenterRoutes.routes,
    ...manualRoutes.routes,
    {
      path: frontendURL('accounts/:account_id'),
      component: AppContainer,
      children: [
        ...conversation.routes,
        ...home.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...crm,
        ...wise,
        ...smart_survey,
        ...typebot,
        ...campaignsFlow,
        ...dashboardEmbed,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      roles: ['administrator', 'agent'],
      component: Suspended,
    },
  ],
};
